import { CircularProgress } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { FAQ_LAYOUTS } from 'src/consumer/components/PrewallAndPaywall/faqComponents/utils'
import FaqSection from 'src/consumer/components/PrewallAndPaywall/FaqSection'
import { getFaqScopeCategories } from 'src/consumer/services/getFaq'
import { MUIThemeConfig } from 'src/context/MUIThemeConfig'
import { useScreenSize } from 'src/customHooks/customHooks'

const scopeId = 'swish-club'
const faqCategoriesMasterList = ['faq-category-d6e538660b8c498e87431703145159b2']

export default function SwishClubFaqs() {
  const [scopeCategories, setScopeCategories] = useState([])
  const [loading, setLoading] = useState(true)

  const { width } = useScreenSize()

  const isMobile = width <= MUIThemeConfig.breakpoints.values.md

  const categoryIdsToUse = useMemo(() => {
    return scopeCategories?.filter(
      (catId) => catId !== 'faq-category-d6e538660b8c498e87431703145159b2',
    )
  }, [scopeCategories])

  useEffect(() => {
    getFaqScopeCategories([scopeId]).then((response) => {
      if (response?.status === 200) {
        setScopeCategories(response.data.data?.faqCategoryList?.map((category) => category.id))
        setLoading(false)
      }
    })
  }, [])

  useEffect(() => {
    console.log(scopeCategories)
  }, [scopeCategories])

  // return (
  //   <div
  //     style={{
  //       background: '#fff',
  //       padding: '10px',
  //       borderRadius: '7px',
  //       maxWidth: '1200px',
  //       width: '100%',
  //       margin: '0px 10px',
  //     }}
  //   >
  //     <FaqSection
  //       // categoryIds={categoryIdsToUse}
  //       categoryIds={faqCategoriesMasterList}
  //       scopeId={scopeId}
  //       layoutType={FAQ_LAYOUTS.SIDEBAR}
  //       renderSpinner={false}
  //     />
  //   </div>
  // )

  return loading ? (
    <></>
  ) : (
    <>
      {categoryIdsToUse?.length > 0 && (
        <div
          style={{
            background: '#fff',
            padding: '10px',
            borderRadius: '7px',
            maxWidth: '1200px',
            width: '100%',
            margin: '0px 10px',
          }}
        >
          <FaqSection
            categoryIds={categoryIdsToUse}
            scopeId={scopeId}
            layoutType={!isMobile ? FAQ_LAYOUTS.SIDEBAR : FAQ_LAYOUTS.DEFAULT}
            // layoutType={FAQ_LAYOUTS.DEFAULT}
            renderSpinner={false}
            keepAllClosedOnRender
          />
        </div>
      )}
    </>
  )
}
